module.exports = __webpack_public_path__ + "static/dashboard_intro3@2x-cf238dca11497e120b4d7c0d449d7b56.png";